import styled from '@emotion/styled';
import { select } from 'src/assets/colors';
import { fontSize, fontWeight } from 'src/assets/fonts-config';
import { ChevronDownIcon } from 'src/assets/icons/ChevronDownIcon';

export const SelectNativeWrapper = styled('div', { label: 'SelectNativeWrapper' })`
       margin-bottom: 16px;
`;

export const SelectNativeWrapperInner = styled('div', { label: 'SelectNativeWrapperInner' })`
    position: relative;
    width: 100%;
`;

interface SelectElementType {
    version?: 'primary' | 'secondary';
}

export const SelectElement = styled('select', { label: 'SelectElement' })<SelectElementType>`
    appearance: none;
    background: ${select.bgColor};
    border-width: 1px;
    border-style: solid;
    border-color: ${({ version }): string => version === 'secondary' ? select.secondary.borderColor : select.primary.borderColor};
    color: ${({ version }): string => version === 'secondary' ? select.secondary.txtColor : select.primary.txtColor};
    font-family: var(--fontFamilyPrimary);
    font-size: ${({ version }): string => version === 'secondary' ? fontSize.small : fontSize.xRegular};
    font-weight: ${({ version }): string => version === 'secondary' ? fontWeight.bold : fontWeight.medium};
    height: 40px;
    line-height: 1.1667;
    padding: 8px 32px 8px 10px;
    width: 100%;

    &:focus-visible {
        border-width: 1px;
        border-style: solid;
        border-color: ${({ version }): string => version === 'secondary' ? select.secondary.borderColor : select.primary.borderColor};
        border-radius: 0;
        outline: none;
    }
`;

export const OptionElement = styled('option', { label: 'OptionElement' })<SelectElementType>`
    background: ${({ version }): string => version === 'secondary' ? select.secondary.bgColor : select.primary.bgColor};
`;

export const ChevronDownWrapper = styled(ChevronDownIcon, { label: 'ChevronDownWrapper' })`
    bottom: 0;
    fill: ${select.bgColorSecondary};
    margin: auto 0;
    pointer-events: none;
    position: absolute;
    inset: 3px 12px 0 auto;
`;
